import { BaseModel } from "sjs-base-model";

export default class SimulazioneLightModel extends BaseModel {
    public readonly idSimulation: string = "";
    public readonly name: string = "";
    public readonly date: string = "";
    public readonly effectiveDate: string = "";
    public readonly hiringDate: string = "";
    public readonly birthDate: string = "";
    public readonly amount: number = 0;
    public readonly payment: number = 0;
    public readonly duration: number = 0;
    public readonly tan: number = 0;
    public readonly teg: number = 0;
    public readonly taeg: number = 0;
    public readonly irr: number = 0;
    public readonly idProduct: number = 0;
    public readonly idRequestedType: number = 0;
    public readonly idChannel: number = 0;
    public readonly idSegment: number = 0;
    public readonly idAdministrativeCategory: number = 0;
    public readonly idAdministration: number = 0;
    public readonly idAgent: number = 0;
    public readonly instalment: number = 0;

    constructor(data: Partial<SimulazioneLightModel>) {
        super();

        this.update(data);
    }
}
